module.exports = __webpack_public_path__ + "img/logo.fef1c210.png";